<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";

const props = defineProps<{
  message: string;
  icon?: string;
  size?: "default" | "small" | "medium" | "large";
}>();

const slots = defineSlots();
const sizeClasses = computed(() => {
  switch (props.size) {
    case "medium":
      return "w-5 h-5 min-w-5 min-h-5";
    case "large":
      return "w-6 h-6 min-w-6 min-h-6";
    case "default":
    default:
      return "w-4 h-4 min-w-4 min-h-4";
  }
});
</script>

<template>
  <div class="empty__container body_regular m-auto text-grey-medium-color">
    <div class="flex justify-center items-center gap-2">
      <SvgIcon v-if="props.icon" :name="props.icon" :class="sizeClasses"></SvgIcon>
      <div class="flex flex-col">
        <span class="body_regular">{{ props.message }}</span>
        <div v-if="slots">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "assets/scss/texts";

.empty__container {
  @apply flex flex-col gap-4 justify-center items-center p-[24px] rounded-[8px];
  border: 1px solid var(--grey-lightest);
  background: var(--grey-light);
  width: 100%;
  height: 92px;
}
</style>
